export const TIER3_ARRIVAL_DWELL_MS = 10_000;
export const TIER3_ARRIVAL_RADIUS_METRES = 35;
export const TIER3_STATIONARY_SPEED_MPS = 0.8;

const toRadians = (degrees) => (Number(degrees) * Math.PI) / 180;

export function distanceMetres(a, b) {
  if (
    a?.latitude == null || a?.longitude == null ||
    b?.latitude == null || b?.longitude == null
  ) return null;

  const lat1 = toRadians(a.latitude);
  const lat2 = toRadians(b.latitude);
  const dLat = lat2 - lat1;
  const dLon = toRadians(Number(b.longitude) - Number(a.longitude));
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 6_371_000 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}

export function nextArrivalDwell(
  previous,
  { device, destination, nowMs, radiusMetres = TIER3_ARRIVAL_RADIUS_METRES,
    dwellMs = TIER3_ARRIVAL_DWELL_MS,
    stationarySpeedMps = TIER3_STATIONARY_SPEED_MPS }
) {
  const distance = distanceMetres(device, destination);
  // Missing GPS speed is unknown, not proof that the vehicle is stationary.
  const speed = device?.speed;
  const hasUsableSpeed = Number.isFinite(speed) && speed >= 0;
  const inside = distance != null && distance <= radiusMetres;
  const stationary = hasUsableSpeed && speed <= stationarySpeedMps;

  if (!inside || !stationary) {
    return { sinceMs: null, ready: false, distanceMetres: distance, inside, stationary };
  }

  const sinceMs = previous?.sinceMs ?? nowMs;
  return {
    sinceMs,
    ready: nowMs - sinceMs >= dwellMs,
    distanceMetres: distance,
    inside,
    stationary,
  };
}
